<template>
    <div class="voiceList">
<!--        <div class="voiceListNull" v-show="dataList.length===0">暂无数据</div>-->
        <div class="inner paddingH16">
            <div v-for="dataItem in dataList" :key="dataItem.id" class="voiceItem flexLayout"
                 @click="viewItem(dataItem)">

                <div class="" style="width: 84px;">
                    <div class="imageArea relative" style="height: 84px">
                        <img class="block fullSpace roundBorder4" :src="dataItem.coverImg" >
                        <img class="icon playIcon size32" src="icon/grey_circle_play_button.svg"/>
                    </div>
                </div>

                <!-- 右边样式 -->
                <div class="flexItem paddingH12">
                    <div class="titleArea" style="margin-bottom: 26px;">
                        <div class="fWeight500 f14">{{dataItem.title}}</div>
                        <div style="color: #8994A9;" class="fWeight400 f12">{{dataItem.introduce}}</div>
                    </div>
                    <div style="color: #8994A9;" class="f12 fWeight400 ">

                        <div class="floatL">{{dataItem.pv}}人收听</div>
                        <div class="floatR">{{dataItem.pv}}次播放</div>
                    </div>
                </div>
            </div>

            <!-- 暂时搜不到内容，搜搜其他内容吧 -->
            <div class="alignC paddingT20 font14r" v-show="dataList.length < 1">
                <img src="notice/notice_no_search_result.png" width="282"/><br/>
                暂时搜不到内容，可
                <span class="blue" @click="contact()">联系师讯客服</span>
                搜索更多内容
            </div>

            <div class="font12r grey60 alignCenter" style="padding: 26px 0 9px;"
                 v-show="status=='ready' && pagination.current == pagination.totalPage"
                 :data-current="pagination.current" :data-total="pagination.totalPage || 0">
                -没有更多啦-
            </div>

        </div>

    </div>
</template>
<script>

import shixunPagePart from '@/components/shixunApp/shixunPagePart';

import bizTypeEnum from '@data/bizTypeEnum';

// util
import appHelper from '@util/appHelper';
import externalApp from "@data/externalApp";

const config = {
    apiConfig : {
        list : {
            url : 'portal/v4/index/search',
            dataPath : 'data.records',
            totalPath : 'data.total',
            totalPagePath : 'data.pages',
            params : {
                bizType : bizTypeEnum.AUDIO.code
            }
        }
    }
};

export default {
    name: "voiceList",
    extends : shixunPagePart,
    data () {
        return {
            apiConfig: config.apiConfig,
            enableDataList : true,
            scrollToLoadNextPage : true
        }
    },
    methods : {
        viewItem(dataItem) {
            appHelper.redirect('/voiceCourse/detail/' + dataItem.id);
        },
        contact() {
            appHelper.redirect(externalApp.oldShixun.baseUrl + 'html/me/contact.html');
        }
    }
};
</script>
<style lang="scss" scope>
.voiceList {
    .voiceItem {
        margin-bottom: 24px;
        &:last-child {
            margin-bottom: 0;
        }
    }
    .imageArea {
        .playIcon {
            position: absolute;
            z-index: 1;
            left: 50%;
            top: 50%;
            margin-top: -16px;
            margin-left: -16px;
        }

    }
    .titleArea {
        line-height: 1.25em;
        height: 2.5em;
        overflow: hidden;
    }
}
</style>
